import { ChangeDetectorRef, Component, AfterViewInit } from '@angular/core';
import { LoadingService } from '@app/core/services/loading.service';

@Component({
  selector: 'dhl-loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements AfterViewInit {
  loading: boolean = false;

  constructor(private readonly loadingService: LoadingService, private readonly cdRef: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    this.loadingService.isLoading.subscribe((isLoading) => {
      this.loading = isLoading;
      this.cdRef.detectChanges();
    });
  }
}
